<template>
    <div>
        <p>
            <strong>В соответствии и во исполнение статей 1341 и 1342 Гражданского кодекса Италии</strong> Пользователь прямо заявляет, что он
            прочитал, понял и принял следующие положения:
        </p>
        <p>Ст. 1 Определения, п. l), «Fleequid», юридическое лицо и применимое налоговое законодательство;</p>
        <p>Ст. 2.3 Комиссии, подлежащие уплате как Продавцом, так и Покупателем;</p>
        <p>Ст. 2.4 Порядок проведения аукционов и определение цены присуждения;</p>
        <p>Ст. 2.5 Процесс перепродажи;</p>
        <p>
            Ст. 3 Утверждение возможных общих условий, предложенных пользователями, одностороннее изменение Общих условий компанией Fleequid и
            иерархия договорных документов;
        </p>
        <p>Ст. 4.5 Ограничения использования Маркетплейса;</p>
        <p>Ст. 4.6 Меры, принимаемые Fleequid в случае нарушения правил использования;</p>
        <p>Ст. 4.7 Расторжение;</p>
        <p>Ст. 4.8 Штраф;</p>
        <p>Ст. 4.10 Отказ от ответственности за функционирование Маркетплейса;</p>
        <p>Ст. 4.11 Удаление учетной записи Пользователя и осуществление права на отказ;</p>
        <p>
            Ст. 6 касающаяся: выраженной оговорки о расторжении, эксклюзивности продажи, условий и срока действия такой эксклюзивности, возможности
            последующего присуждения, ограничений продажи, возможности аннулирования или расторжения продажи в случае просрочки или неоплаты
            Покупателем, отказа Продавца от возражений или требований, освобождения от ответственности, технического досье, штрафных санкций,
            налагаемых на Продавца;
        </p>
        <p>
            Ст. 7 Приглашение к подаче предложений (invitatio ad offerendum), срок действия безотзывного предложения о покупке, специальные условия
            аукциона, резервная цена;
        </p>
        <p>Ст. 8.4 Порядок обращения с гарантийным депозитом;</p>
        <p>Ст. 9.3 Оплата цены транспортного средства;</p>
        <p>
            Ст. 9.4 Предварительное выставление счета по запросу Fleequid, отлагательное условие оплаты, зависящее от полного получения средств от
            Покупателя (pay-when-paid), обязанность выставления кредит-ноты в случае неоплаты или аннулирования продажи, право зачета, ежедневные
            штрафы за просрочку или бездействие и отказ Продавца от возражений или требований в отношении Fleequid;
        </p>
        <p>Ст. 9.5 Штраф;</p>
        <p>Ст. 9.7 и 9.8 Сроки уведомления о дефектах и неисправностях;</p>
        <p>Ст. 9.10 Выраженная оговорка о расторжении и штраф;</p>
        <p>
            Ст. 10 Условия оплаты, расторжение, штрафы, условия, регулирующие перепродажу и освобождение от ответственности, пробег, сроки проверки
            дефектов при передаче;
        </p>
        <p>
            Ст. 11 Исключение гарантий и освобождение Fleequid от ответственности, переход риска, выраженная оговорка о расторжении, штрафы, право
            аннулирования продажи, исключение скрытых дефектов, пределы ответственности, основанные на пробеге и возрасте транспортного средства;
        </p>
        <p>
            Ст. 13 Претензии, предложения по урегулированию претензий, урегулирование претензии Fleequid путем аннулирования продажи, скрытые дефекты,
            освобождение от ответственности, оговорка «как есть», штрафы;
        </p>
        <p>Ст. 14 Связывающая оговорка;</p>
        <p>Ст. 15 Применимое право, язык и подсудность.</p>
    </div>
</template>
